


import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { withRouter } from 'react-router-dom';
import LoadingSpinner from "src/components/LoadingSpinner";
import Headerpage from "src/components/header";
import Footerpage from "src/components/footer";
const styles = () => ({
    childTemplate: {
        paddingLeft: 80,
    },
    listItem: {
        "&:hover": {
            backgroundColor: "#e6e6e6",
        },
        backgroundColor: "white",
    },
});

type IProps = IAxiosProps & IAppContext &
    WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
    paymentDetails: any
    loader: boolean;
    openAgreement: boolean;
    paymentMethodType: number;
    isAgree: boolean;
    selectedFile: any;
    agrrementtt: any;
}

const PaybyStripe = withStyles(styles)(
    withAxios(
        class PaybyStripePage extends Component<IProps, ITemplatesPageState> {
            public state = this.buildState({
                paymentDetails: {},
                loader: false,
                openAgreement: false,
                paymentMethodType: 0,
                isAgree: false,
                selectedFile: null,
                agrrementtt: ""
            });           
            // public handlePopState: (event: any) => void;
            public componentWillMount(): void {
                this.props.getNewLoginUserDetails()
            }

            public async componentDidMount() {
                console.log("stripe this.props", this.props)
                this.setState({agrrementtt: this.props?.newUserDetails?.agreementFile || "default"})
                console.log("this prop 3", this.props)
                if(this.props?.user?.email || this.props?.newUserDetails?.email){
                const isCheck = await this.emailExistingCheck()
                console.log("is check and this.state.agrrementtt", isCheck, this.state.agrrementtt)
                 if (isCheck) {
                    this.getStripeDatails()
                } else {
                    alert("This email is already registered. Please try another one.")
                }
            }else{
                alert("Complete sign-up flow first.")
            }
                window.history.pushState(null, "", window.location.href);

                // this.handlePopState = (event) => {
                //     // Prevent back button by pushing a new entry again
                //     window.history.pushState(null, "", window.location.href);
                // };

                // Add an event listener to detect back button navigation
               // window.addEventListener('popstate', this.handlePopState);
            }
            public async emailExistingCheck() {
                if(this.props?.user?.email || this.props?.newUserDetails?.email){
                    this.setState({ loader: true })
                
                    const resEmail: any = await this.buildGet(this, `school/user/${this.props?.user?.email || this.props?.newUserDetails?.email}`)()
                    console.log("resEmail======>", this.props.user.email, resEmail.status)
                    if (Object.keys(resEmail?.status).length > 0) {
                        this.setState({ loader: false })
                        return false
                    } else {
                        this.setState({ loader: false })
                        return true
                    }
                }else{
                    return false
                }
              
            }
            public handleBackButton = (event: PopStateEvent) => {
                console.log(event, "EVENT====>?")
            };
            public componentWillUnmount() {
                // window.removeEventListener('popstate', this.handlePopState);
            }

            public normalizeSchoolType(value: any) {
                const schoolType = (value || "").toString().trim().toLowerCase();
                if (schoolType === "middle_school") {
                    return "middle";
                }
                return value || "";
            }

            public getStripeDatails = async () => {
                console.log("inside stripe prop", this.props)
                const dataTemp = {
                    payment_method: 'stripe',
                    plan_id: this.props?.newUserDetails?.subscriptionPlan?.id?.toString(),
                    // agreements: this.props?.newUserDetails?.agreementFile || "",
                    agreements: this.state.agrrementtt,
                    email: this.props?.user?.email || this.props?.newUserDetails?.email.toLowerCase() || "",
                    password:  this.props?.newUserDetails?.password || "",
                    firstName: this.props?.newUserDetails?.firstName || "",
                    lastName: this.props?.newUserDetails?.lastName || "",
                    schoolOrganization: this.props?.newUserDetails?.schoolOrganization || "",
                    mascot: this.props?.newUserDetails?.mascot || "",
                    phone: this.props?.newUserDetails?.phone || "",
                    addon_id: this.props?.newUserDetails?.addonPlan || [],
                    schoolType: this.normalizeSchoolType(this.props?.newUserDetails?.schoolType)
                }
                this.setState({ loader: true })
                const data = new FormData();
                console.log("dataTemp.agreements", dataTemp)
                data.append('payment_method', dataTemp.payment_method);
                data.append('agreements', dataTemp.agreements);
                data.append('email', dataTemp.email);
                data.append('password', dataTemp.password);
                data.append('firstName', dataTemp.firstName);
                data.append('lastName', dataTemp.lastName);
                data.append('plan_id', dataTemp.plan_id)
                data.append('schoolOrganization', dataTemp.schoolOrganization);
                data.append('mascot', dataTemp.mascot);
                data.append('phone', dataTemp.phone);
                data.append('schoolType', dataTemp.schoolType);
                if (dataTemp?.addon_id?.length > 0) {
                    dataTemp.addon_id.map((itm: any) => {
                        data.append('addon_id[]', itm.toString());

                    })

                }
                console.log("FormData agreements:", data.get('agreements'));
                const res: any = await this.buildPost(
                    this,
                    `/payment/planPayConfirmStripe`
                )(data);
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    stripeResponse: res,
                    isStripe: true
                });

console.log("/payment/planPayConfirmStripe", res)
                if (res?.status) {
                    this.setState({ loader: false, })
                    // this.setState({ paymentDetails: res?.data ,loader: false,})
                    // window.open(res?.data?.payment_url, '_blank');
                    window.location.href = res?.data?.payment_url
                } else {
                    this.setState({ loader: false, })
                }

            }
            public render() {
                return (
                    <>
                       <div className="contat-main-bg-color">
                      {this.state.loader &&<div className="loader-bg-color">
                        <LoadingSpinner /></div>}
                        <Headerpage/>


                        <div className="container">

                            <div style={{ height: "100vh" }} className="payemt-rel">
                                {this.state.paymentDetails?.payment_url && <iframe
                                    src={this.state.paymentDetails?.payment_url}
                                    style={{ width: "100%", height: "100%", border: "none" }}
                                    title="Web Page"
                                />}
                            </div>

                        </div>


                                                <Footerpage/>
                        </div>
                    </>
                );
            }
        }
    )
);



const PaybyStripeFunction = (props: any) => (
    <AppContextConsumer>{(context) => <PaybyStripe {...context} history={props?.history} />}</AppContextConsumer>
);
export default withRouter(PaybyStripeFunction);












// WEBPACK FOOTER //
// ./src/pages/director/payment/PaybyStripe.tsx